module.exports = __webpack_public_path__ + "static/media/1012833.50575b79.png";